import { useCallback, useMemo, useState } from 'react';
import { AuthenticatedUserContext } from "@ngt/forms";
import { ResponseStatus, ToggleRegistrationStatus, ToggleRegistrationStatusResponse, UserDto } from '../api/dtos';
import { JsonServiceClient } from '@servicestack/client';
import { client } from '../api/client';


const serviceStackClient: JsonServiceClient = client;

export const useUpdateRegistrationStatus = (id?: number) => {

    const [pending, setPending] = useState<boolean>(false);
    const [error, setError] = useState<ResponseStatus>();

    const updateRegistration = useCallback(async (id?: number) => {

        if(id){
            setPending(true);
            const request = new ToggleRegistrationStatus();
            request.id = id;
            let response: ToggleRegistrationStatusResponse | undefined = undefined;
            try{
                response = await serviceStackClient.patch(request);
                setPending(false);
            }
            catch(e: any){
                setError(e.responseStatus)
                setPending(false);
            }
    
            return response;
        }

    }, [id]);

    const updateRegistrationService = useMemo(() => {
        return {
            updateRegistration, 
            pending,
        }
    }, [id, pending]);

    return updateRegistrationService;
}

export default useUpdateRegistrationStatus;
